/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiFormFromJSON, ApiFormToJSON, } from './ApiForm';
import { ApiFormRuleTypeFromJSON, ApiFormRuleTypeToJSON, } from './ApiFormRuleType';
export function ApiFormRuleFromJSON(json) {
    return ApiFormRuleFromJSONTyped(json, false);
}
export function ApiFormRuleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'form': !exists(json, 'form') ? undefined : ApiFormFromJSON(json['form']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'mapping': !exists(json, 'mapping') ? undefined : json['mapping'],
        'target': !exists(json, 'target') ? undefined : json['target'],
        'type': !exists(json, 'type') ? undefined : ApiFormRuleTypeFromJSON(json['type']),
    };
}
export function ApiFormRuleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'form': ApiFormToJSON(value.form),
        'id': value.id,
        'mapping': value.mapping,
        'target': value.target,
        'type': ApiFormRuleTypeToJSON(value.type),
    };
}
